/* HAND-MAINTAINED in clients/profit_minded/theme_variant_b (NOT generated here).
   theme_variant_a's copy is generated by site_rebuild/_gen_mockups.py -> _derive_assets.py; the
   homepage-v2 line edited it on the theme directly, so that pipeline no longer describes this
   file. Edit it here and never run _derive_assets.py against this tree (PLAN decision C3).
   2026-09-22: Shipping Protection & Free Exchanges — see the SHIPPING PROTECTION block below. */
/* ===== pm-cart.js ==========================================================
   Everything it reads comes from the DOM: the free-shipping threshold from a
   data-* attribute in cents, copy from an application/json blob, the protection
   config from another, and the initial cart from {{ cart | json }}.

   TWO CARTS, NEVER CONFUSED (Codex R2 #2):
     SERVER  the last cart Shopify returned. Every DECISION reads this —
             reconcile, checkout, retry detection, protection counts.
     CART    what is painted: SERVER plus optimistic overlays (provisional add
             lines, un-acked quantity steps). Only PAINTING reads this.
   Transient per-line flags on CART: _loading (overlay pending), _error (sticky;
   cleared only by a successful retry of that line).
   ========================================================================= */
(function () {
  var root = document.querySelector('[data-pm-drawer]');
  if (!root) return;

  var THRESHOLD = parseInt(document.body.getAttribute('data-pm-freeship-threshold') || '0', 10);
  var DEBOUNCE  = 350;

  var STR  = JSON.parse(document.querySelector('[data-pm-cart-strings]').textContent);
  var INIT = JSON.parse(document.querySelector('[data-pm-cart-state]').textContent);
  var PROT = (function () {
    var el = document.querySelector('[data-pm-protect]');
    var p = null;
    try { p = el ? JSON.parse(el.textContent) : null; } catch (e) { p = null; }
    p = p || {};
    return {
      active: !!p.active,
      product_id: p.product_id || null,
      variant_id: p.variant_id || null,
      identity_id: p.identity_id || null,
      price: p.price || 0,
      title: p.title || '',
      checkout_url: p.checkout_url || '/cart/checkout'
    };
  })();
  var CHANGE_URL = (window.theme && theme.routes && theme.routes.cart_change_url) || '/cart/change';

  function clone(o) { return JSON.parse(JSON.stringify(o)); }
  var SERVER = clone(INIT);
  var CART = clone(INIT);
  var overlays = [];     /* provisional add lines: {line} */
  var ovSeq = 0;
  var qtyOverlay = {};   /* line key -> optimistic quantity awaiting the server */
  var errKeys = {};      /* line key -> sticky error */

  var elLines = root.querySelector('[data-pm-lines]');
  var elEmpty = root.querySelector('[data-pm-empty]');
  var elFoot  = root.querySelector('[data-pm-drawer-foot]');
  var elCount = root.querySelector('[data-pm-drawer-count]');
  var elSub   = root.querySelector('[data-pm-subtotal]');
  var elShip     = root.querySelector('[data-pm-ship]');
  var elShipMsg  = root.querySelector('[data-pm-ship-msg]');
  var elShipFill = root.querySelector('[data-pm-ship-fill]');
  var panel   = root.querySelector('.pm-drawer__panel');

  /* ---- the /cart page, when we are on it (all null elsewhere) ---- */
  var pageRoot   = document.querySelector('[data-pm-cartpage]');
  var pgLines    = pageRoot && pageRoot.querySelector('[data-pm-page-lines]');
  var pgEmpty    = pageRoot && pageRoot.querySelector('[data-pm-page-empty]');
  var pgForm     = pageRoot && pageRoot.querySelector('[data-pm-page-form]');
  /* The empty/populated toggle is the GRID, not the form: the server renders
     `hidden` on the grid, so the JS must toggle that same element. */
  var pgGrid     = pageRoot && pageRoot.querySelector('[data-pm-page-grid]');
  var pgCount    = pageRoot && pageRoot.querySelector('[data-pm-page-count]');
  var pgSub      = pageRoot && pageRoot.querySelector('[data-pm-page-subtotal]');
  var pgSide     = pageRoot && pageRoot.querySelector('[data-pm-page-side]');
  var pgDisc     = pageRoot && pageRoot.querySelector('[data-pm-page-discount]');
  var pgDiscV    = pageRoot && pageRoot.querySelector('[data-pm-page-discount-value]');
  var pgShipMsg  = pageRoot && pageRoot.querySelector('[data-pm-page-ship-msg]');
  var pgShipFill = pageRoot && pageRoot.querySelector('[data-pm-page-ship-fill]');

  /* Queued + in-flight cart operations (adds and quantity steps). Drives the busy
     styling only: checkout is no longer disabled while busy — it is QUEUED behind
     everything before it (see flushPending + run), which is strictly better than a
     dead button (rulebook: a silent tap is a broken feature). */
  var busyCount = 0;
  /* Set by a checkout action from the moment it is queued until it navigates or
     fails. While set, adds and quantity steps are no-ops that repaint (Codex R3 #3). */
  var locked = false;

  /* Set from JS, deliberately NOT from an inline <head> script: it must mean "the cart
     script is actually running". */
  document.documentElement.classList.add('pm-js');

  /* ===== THE ONLY NETWORK BOUNDARY ==========================================
     Every request this file makes goes through api(). A 4xx (except 429) is marked
     `definitive`: Shopify refused the write. Network errors, 5xx, 429 and
     unparseable bodies are AMBIGUOUS: the write may have landed, or may yet land.
     ========================================================================= */
  function api(path, body) {
    var opts = { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(path, opts).then(function (r) {
      if (!r.ok) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          var e = new Error(j.description || j.message || ('HTTP ' + r.status));
          e.status = r.status;
          e.definitive = r.status >= 400 && r.status < 500 && r.status !== 429;
          throw e;
        });
      }
      return r.json().catch(function () {
        var e = new Error('unparseable response'); e.definitive = false; throw e;
      });
    });
  }

  /* ===== ONE ROUND TRIP PER ADD (2026-09-11) ================================
     /cart/add.js returns the added LINE, not the cart. Bundled Section Rendering
     asks for sections/pm-cart-json.liquid in the same request, which carries the
     whole cart. If that section is missing/empty/unparseable, fall through to
     GET /cart.js — degrade to two trips, never to a broken cart.
     ========================================================================= */
  var CART_SECTION = 'pm-cart-json';

  function cartFromSections(payload) {
    var html = payload && payload.sections && payload.sections[CART_SECTION];
    if (!html) return null;
    try {
      var host = document.createElement('div');
      host.innerHTML = html;
      var node = host.querySelector('[data-pm-cart-json]');
      if (!node) return null;
      var cart = JSON.parse(node.textContent);
      if (!cart || !Array.isArray(cart.items) || typeof cart.total_price !== 'number') return null;
      return cart;
    } catch (e) {
      return null;
    }
  }

  function postAdd(items) {
    return api('/cart/add.js', {
      items: items,
      sections: CART_SECTION,
      sections_url: location.pathname
    }).then(function (payload) {
      return cartFromSections(payload) || api('/cart.js');
    });
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function find(key) {
    for (var i = 0; i < CART.items.length; i++) if (CART.items[i].key === key) return CART.items[i];
    return null;
  }

  /* ===== SHIPPING PROTECTION (2026-09-22) ====================================
     Derrick: "make a product called Shipping Protection & Free Exchanges that gets
     auto added to cart and in the cart lets have an option for protected checkout
     as the main option in cart to checkout and line of text under it that says
     continue without protected checkout".
     PLAN: .planning/profit-minded-v2-protection-search-reviews/PLAN.md §4.3 —
     Codex-approved over 5 rounds; the rules below are that review's findings.

     MANAGED vs IDENTITY (one rule, shared with snippets/pm-protect.liquid):
       isManaged — PROT.active and the protection product. Hidden from the list,
                   not counted, not in the free-ship total, shown in the row.
       isIdentity — the protection product, active or not. Used ONLY for explicit
                   removal ("continue without") and its assertion, so a line left
                   behind by a switch-off is still removed (Codex R3 #2).

     INVARIANTS over SERVER, re-checked after every settled mutation (Codex R1 #2):
       I1 no real items          => 0 managed units (no orphan fee in an empty bag)
       I2 attribute declined     => 0 managed units
       I3 otherwise, if active   => exactly 1 managed unit
     The shopper's choice lives in the cart attribute `_pm_protection`
     (declined | accepted): it travels with the cart the checkout uses and shows on
     the order in admin.
     ========================================================================= */
  function isManaged(l) { return !!(PROT.active && l && l.product_id && l.product_id === PROT.product_id); }
  function isIdentity(l) { return !!(PROT.identity_id && l && l.product_id === PROT.identity_id); }
  function managedLines(c) { return (c.items || []).filter(isManaged); }
  function identityLines(c) { return (c.items || []).filter(isIdentity); }
  function units(lines) { return lines.reduce(function (n, l) { return n + (l.quantity || 0); }, 0); }
  function realCount(c) {
    return (c.items || []).reduce(function (n, l) { return isManaged(l) ? n : n + (l.quantity || 0); }, 0);
  }
  function realTotal(c) {
    return (c.items || []).reduce(function (t, l) {
      if (isManaged(l)) return t;
      var v = (typeof l.final_line_price === 'number') ? l.final_line_price : (l.price || 0) * (l.quantity || 0);
      return t + v;
    }, 0);
  }
  function choice(c) { return (c.attributes && c.attributes._pm_protection) || ''; }
  function qtyOf(c, variantId) {
    variantId = Number(variantId);
    return (c.items || []).reduce(function (n, l) { return l.id === variantId ? n + l.quantity : n; }, 0);
  }

  /* Adopt a server cart as the new SERVER truth, then rebuild what is painted as
     SERVER + every overlay still pending. A sticky error on some OTHER line is not
     silently swallowed by this line's success. */
  function adopt(cart) {
    SERVER = clone(cart);
    rebuildPaint();
  }
  function rebuildPaint() {
    var c = clone(SERVER);
    var n = SERVER.item_count || 0, t = SERVER.total_price || 0;
    c.items.forEach(function (l) {
      l._loading = false;
      if (errKeys[l.key]) l._error = true;
      if (Object.prototype.hasOwnProperty.call(qtyOverlay, l.key)) {
        var q = qtyOverlay[l.key], d = q - l.quantity;
        n += d; t += d * (l.price || 0);
        l.quantity = q;
        l.final_line_price = (l.price || 0) * q;
        l._loading = true;
      }
    });
    overlays.forEach(function (o) {
      var line = clone(o.line);
      c.items.push(line);
      n += line.quantity; t += line.final_line_price;
    });
    c.item_count = n;
    c.total_price = Math.max(0, t);
    CART = c;
  }

  /* ---- ONE serial queue for every cart mutation (Codex R1 #1, R2 #1) ---- */
  var queue = Promise.resolve();
  function noop() {}
  function run(fn) {
    var p = queue.then(fn);
    queue = p.then(noop, noop);
    return p;
  }

  /* ONE line renderer for BOTH hosts. `forPage` only decides whether the quantity
     input carries name="updates[]" (the cart page's no-JS form maps it BY CART-LINE
     ORDER). Everything else is byte-identical on purpose. */
  function lineHTML(l, forPage) {
    var frame = '';
    if (l.image) {
      var w = forPage ? 240 : 160;
      frame = '<img src="' + esc(String(l.image).split('?')[0] + '?width=' + w) +
              '" alt="" width="' + (forPage ? 120 : 64) + '" height="' +
              (forPage ? 150 : 80) + '" loading="lazy">';
    }
    var vt = (l.variant_title && l.variant_title !== 'Default Title') ? l.variant_title : '';
    return '<li class="pm-line" data-pm-line data-key="' + esc(l.key) + '" data-loading="' +
      (l._loading ? 'true' : 'false') + '">' +
      '<div class="pm-line__frame">' + frame + '</div>' +
      '<div class="pm-line__body">' +
        '<a class="pm-line__title t-product" href="' + esc(l.url) + '">' + esc(l.product_title) + '</a>' +
        (vt ? '<span class="pm-line__opt t-price">' + esc(vt) + '</span>' : '') +
        '<div class="pm-line__row">' +
          '<span class="pm-qty">' +
            '<button type="button" class="t-nav" data-pm-qty-dec aria-label="Decrease quantity">&minus;</button>' +
            '<input class="t-price" type="number" inputmode="numeric" min="0" value="' + l.quantity +
              '"' + (forPage ? ' name="updates[]"' : '') + ' data-pm-qty-input aria-label="Quantity">' +
            '<button type="button" class="t-nav" data-pm-qty-inc aria-label="Increase quantity">+</button>' +
          '</span>' +
          '<span class="t-price" data-pm-line-total>' + money(l.final_line_price) + '</span>' +
        '</div>' +
        '<div class="pm-line__row">' +
          '<button type="button" class="pm-line__remove t-label" data-pm-line-remove>Remove</button>' +
        '</div>' +
        (l._error ? '<p class="pm-line__err t-label">' + esc(STR.line_error) + '</p>' : '') +
      '</div></li>';
  }
  /* The managed protection line on the /cart page: not an item, but its updates[]
     field keeps its POSITION so the no-JS form can never shift quantities. */
  function protectLineHTML(l) {
    return '<li class="pm-line pm-line--protect" data-pm-line data-key="' + esc(l.key) + '" hidden>' +
      '<input type="hidden" name="updates[]" value="' + l.quantity + '"></li>';
  }

  function render() {
    var n = realCount(CART), empty = n === 0;
    root.setAttribute('data-empty', empty ? 'true' : 'false');
    elCount.textContent = n ? '(' + n + ')' : '';
    [].forEach.call(document.querySelectorAll('[data-pm-bag-count]'), function (b) {
      b.textContent = n;
      b.setAttribute('data-empty', empty ? 'true' : 'false');
    });
    elEmpty.hidden = !empty;
    elLines.hidden = empty;
    elFoot.hidden = empty;
    elShip.hidden = empty;
    /* NOT `.map(lineHTML)` — Array.map passes the INDEX as lineHTML's second argument. */
    elLines.innerHTML = CART.items
      .filter(function (l) { return !isManaged(l); })
      .map(function (l) { return lineHTML(l, false); }).join('');
    elSub.textContent = money(CART.total_price);
    ship();
    paintProtect();
    syncUpsell();
    renderPage();
    try {
      document.dispatchEvent(new CustomEvent('pm:cart:updated', { detail: CART }));
    } catch (e) {}
  }

  function renderPage() {
    if (!pageRoot) return;
    var n = realCount(CART), empty = n === 0;
    pageRoot.setAttribute('data-empty', empty ? 'true' : 'false');
    if (pgEmpty) pgEmpty.hidden = !empty;
    if (pgGrid) pgGrid.hidden = empty;
    if (pgCount) pgCount.textContent = n ? '(' + n + ')' : '';
    if (pgLines) {
      pgLines.innerHTML = CART.items.map(function (l) {
        return isManaged(l) ? protectLineHTML(l) : lineHTML(l, true);
      }).join('');
    }
    if (pgSub) pgSub.textContent = money(CART.total_price);
    /* Server truth only: total_discount is whatever the server last said. */
    if (pgDisc) {
      var d = SERVER.total_discount || 0;
      pgDisc.hidden = !(d > 0) || busyCount > 0;
      if (d > 0 && pgDiscV) pgDiscV.textContent = '-' + money(d);
    }
    if (pgShipMsg && THRESHOLD) {
      var tot = realTotal(CART);
      var rem = Math.max(0, THRESHOLD - tot);
      pgShipMsg.textContent = rem === 0 ? STR.freeship_reached
        : STR.freeship_progress.replace('{amount}', money(rem));
      if (pgShipFill) pgShipFill.style.width = Math.min(100, Math.round(tot / THRESHOLD * 100)) + '%';
    }
    syncBusy();
  }

  function syncBusy() {
    if (pgSide) pgSide.setAttribute('data-busy', busyCount > 0 ? 'true' : 'false');
  }

  /* Free-shipping bar: REAL total, protection excluded (PLAN C8 — it may not count
     toward Shopify's rate condition, so the bar may only ever promise less). */
  function ship() {
    if (!THRESHOLD || !elShipMsg) return;
    var tot = realTotal(CART);
    var remaining = Math.max(0, THRESHOLD - tot);
    elShipMsg.textContent = remaining === 0
      ? STR.freeship_reached
      : STR.freeship_progress.replace('{amount}', money(remaining));
    elShipFill.style.width = Math.min(100, Math.round(tot / THRESHOLD * 100)) + '%';
  }

  /* The protection row, primary label and skip link on BOTH hosts. */
  function paintProtect() {
    var on = PROT.active;
    var has = units(managedLines(CART)) > 0;
    var anyId = units(identityLines(CART)) > 0;
    [].forEach.call(document.querySelectorAll('[data-pm-protect-row]'), function (r) {
      r.hidden = !on;
      r.setAttribute('data-state', has ? 'on' : 'off');
      var price = r.querySelector('[data-pm-protect-price]');
      if (price && on) price.textContent = money(PROT.price);
      var title = r.querySelector('.pm-protect__title');
      if (title && on && PROT.title) title.textContent = PROT.title;
    });
    [].forEach.call(document.querySelectorAll('[data-pm-protect-go]'), function (g) {
      if (g.getAttribute('aria-busy') === 'true') return;
      g.textContent = on ? (STR.protect_cta || STR.checkout) : STR.checkout;
    });
    var key = (managedLines(CART)[0] || identityLines(CART)[0] || {}).key;
    [].forEach.call(document.querySelectorAll('[data-pm-protect-skip]'), function (s) {
      s.hidden = !(on || anyId);
      s.setAttribute('href', key
        ? CHANGE_URL + '?id=' + encodeURIComponent(key) + '&quantity=0&return_to=' + encodeURIComponent(PROT.checkout_url)
        : PROT.checkout_url);
    });
  }

  /* ---- reconcile: converge SERVER to I1–I3 (computed INSIDE the queue) ---- */
  var tries = {}, warned = {};
  function signature(c) {
    return [c.token || '', (c.items || []).map(function (l) { return l.key + ':' + l.quantity; }).sort().join(','), choice(c)].join('|');
  }
  function planFor(c) {
    var ml = managedLines(c), u = units(ml), upd = {};
    if (realCount(c) === 0 || choice(c) === 'declined') {
      if (u === 0) return null;
      ml.forEach(function (l) { upd[l.key] = 0; });
      return upd;
    }
    if (!PROT.active || u === 1) return null;
    if (u === 0) { upd[PROT.variant_id] = 1; return upd; }
    ml.forEach(function (l, i) { upd[l.key] = i === 0 ? 1 : 0; });
    return upd;
  }
  function reconcile() {
    run(function () {
      if (locked) return;
      /* A possibly-stale SERVER is refreshed first; if that fails, write nothing (rk plan R3 #2). */
      return ensureFresh().then(function () {
        var upd = planFor(SERVER);
        if (!upd) return;
        var sig = signature(SERVER);
        tries[sig] = (tries[sig] || 0) + 1;
        if (tries[sig] > 2) {
          if (!warned[sig]) {
            warned[sig] = 1;
            try { console.warn('[pm-cart] shipping protection could not be reconciled for this cart; leaving it as is.'); } catch (e) {}
          }
          return;
        }
        return api('/cart/update.js', { updates: upd }).then(function (cart) {
          adopt(cart); render();
        }, noop);   /* the cart is valid either way; a loop would be worse than a missing fee */
      }, noop);
    });
  }

  /* ---- mutations ----
     QUANTITY EDITS ARE INTENT, NOT ABSOLUTE TARGETS (2026-09-23, "rk" fix —
     .planning/profit-minded-v2plus-rk-fix/PLAN.md, Codex-approved over 5 rounds).
     TRIPLE-TEE (BXGY) splits one variant into paid + free lines with DIFFERENT keys and
     re-keys them whenever the allocation changes. A change queued for key K could land
     after K no longer existed and was silently lost (two quick taps: 3 -> 2 tees). So:
       - a key's CYCLE records what the shopper SAW (`cycleBase`) and the line's identity
         (variant + properties + selling plan) when it starts;
       - `sendQty` snapshots {key, ident, base, target, seq} at ENQUEUE, so a newer cycle
         can never consume this one's baseline;
       - inside the queue `aim` applies the DELTA to the confirmed SERVER, across every
         equivalent line (the split/merged lines of that variant), original key first;
       - failure never replays: resync, say so, and latch checkout (failQty/gate). */
  var timers = {}, pendingQty = {};
  var cycleBase = {}, cycleIdent = {}, cycleSeq = {};
  var qtyFailSeq = 0;    /* bumped FIRST on every failed/unappliable quantity edit */
  var qtyShownSeq = 0;   /* the last failure whose recovery the shopper has SEEN rendered */
  var needResync = false;  /* SERVER may be stale (a write + its recovery GET both failed) */
  function has(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
  function identOf(l) {
    var sp = l.selling_plan_allocation && l.selling_plan_allocation.selling_plan;
    return String(l.id) + '|' + JSON.stringify(l.properties || {}) + '|' + (sp ? sp.id : '');
  }
  /* Gate for EVERY queued step that reads SERVER to decide a write: a stale SERVER is
     refreshed (and SHOWN) first; if that fails the caller writes nothing. */
  function ensureFresh() {
    if (!needResync) return Promise.resolve();
    return api('/cart.js').then(function (cart) {
      adopt(cart); render();
      needResync = false;
    });
  }
  function showQtyMsg() {
    [].forEach.call(document.querySelectorAll('[data-pm-protect-msg]'), function (m) {
      m.textContent = STR.line_error || '';
      m.hidden = !STR.line_error;
    });
  }
  function setQty(key, qty) {
    if (locked) { render(); return; }
    var line = find(key);
    if (!line) return;
    if (qty < 0) qty = 0;
    if (!timers[key] && !has(pendingQty, key)) {
      busyCount++;              /* one increment per key cycle, released when its request settles */
      cycleBase[key] = line.quantity;   /* the PAINTED quantity: what the shopper saw */
      cycleIdent[key] = identOf(line);
      cycleSeq[key] = (cycleSeq[key] || 0) + 1;
    }
    qtyOverlay[key] = qty;
    pendingQty[key] = qty;
    delete errKeys[key];
    rebuildPaint(); render();
    clearTimeout(timers[key]);
    timers[key] = setTimeout(function () { timers[key] = null; sendQty(key); }, DEBOUNCE);
  }
  /* Where does this cycle's intent land on the CONFIRMED cart? null = nothing to send,
     'lost' = an increase whose line group no longer exists (never blindly re-added). */
  function aim(c, s) {
    if (typeof s.base !== 'number') {   /* unreachable: every sendQty follows a cycle-starting setQty */
      return { path: '/cart/change.js', body: { id: s.key, quantity: s.target } };
    }
    var delta = s.target - s.base;
    if (delta === 0) return null;
    var group = (c.items || []).filter(function (l) { return !isManaged(l) && identOf(l) === s.ident; });
    var own = group.filter(function (l) { return l.key === s.key; })[0];
    var bySize = group.slice().sort(function (a, b) { return b.quantity - a.quantity; });
    if (delta > 0) {
      if (!group.length) return 'lost';
      var t = own || bySize[0];
      /* change.js, not update.js: it keeps Shopify's inventory validation (Codex R1 #2). */
      return { path: '/cart/change.js', body: { id: t.key, quantity: t.quantity + delta } };
    }
    var need = -delta, upd = {}, n = 0;
    (own ? [own] : []).concat(bySize.filter(function (l) { return l !== own; })).forEach(function (l) {
      if (need <= 0) return;
      var take = Math.min(need, l.quantity);
      if (take > 0) { upd[l.key] = l.quantity - take; need -= take; n++; }
    });
    if (!n) return null;                /* nothing of it left to remove */
    var keys = Object.keys(upd);
    if (keys.length === 1) return { path: '/cart/change.js', body: { id: keys[0], quantity: upd[keys[0]] } };
    return { path: '/cart/update.js', body: { updates: upd } };   /* a decrease across split lines: one write */
  }
  /* Cycle-specific cleanup: a NEWER cycle for the same key keeps its overlay. */
  function settleQty(s) {
    if (!has(pendingQty, s.key) && (cycleSeq[s.key] || 0) === s.seq) delete qtyOverlay[s.key];
    busyCount--;
  }
  /* ONE failure settlement (rejected write, unappliable increase, or failed resync).
     Order matters: the latch moves FIRST, before anything that can fail or wait. */
  function failQty(s, resyncFailed) {
    qtyFailSeq++;
    var mine = qtyFailSeq;
    settleQty(s);
    errKeys[s.key] = true;              /* shown only if that line still exists */
    showQtyMsg();                       /* cart-level: a vanished key's line error would be invisible */
    function after() {
      rebuildPaint(); render(); showQtyMsg();
      qtyShownSeq = mine;               /* the shopper has now SEEN this recovery */
      reconcile();
    }
    if (resyncFailed) { needResync = true; after(); return; }
    return api('/cart.js').then(function (cart) {
      adopt(cart); needResync = false; after();
    }, function () { needResync = true; after(); });
  }
  /* The debounced step ENQUEUES (it never sends out of order with an add or a checkout). */
  function sendQty(key) {
    if (!has(pendingQty, key)) return;
    var s = { key: key, target: pendingQty[key], base: cycleBase[key], ident: cycleIdent[key], seq: cycleSeq[key] || 0 };
    delete pendingQty[key]; delete cycleBase[key]; delete cycleIdent[key];
    run(function () {
      return ensureFresh().then(function () {
        var req = aim(SERVER, s);
        if (req === null) { settleQty(s); rebuildPaint(); render(); return; }
        if (req === 'lost') return failQty(s);
        /* Clear the busy flag BEFORE the paint that consumes it (SKILL trap #16). */
        return api(req.path, req.body).then(function (cart) {
          settleQty(s);
          adopt(cart); render();
          reconcile();
        }, function () { return failQty(s); });
      }, function () { return failQty(s, true); });   /* resync failed: write nothing */
    });
  }
  /* Checkout calls this FIRST: every step still inside its debounce is enqueued now,
     so the checkout action runs strictly after every edit the shopper made. */
  function flushPending() {
    Object.keys(timers).forEach(function (key) {
      if (timers[key]) { clearTimeout(timers[key]); timers[key] = null; sendQty(key); }
    });
  }

  /* Add is OPTIMISTIC: the drawer opens on the tap's own frame with a provisional
     line (an overlay on CART); the network runs in the queue and the server's answer
     wins. If the request fails the provisional line is dropped and the error surfaces. */
  function add(variantId, qty, btn, preview, opts) {
    var n = qty || 1;
    var wantOpen = !(opts && opts.open === false);
    if (locked) { render(); if (wantOpen) open(); return Promise.resolve(); }
    if (btn) { btn.setAttribute('data-busy', 'true'); btn.disabled = true; }

    var ov = null;
    if (preview) {
      ov = { line: {
        key: 'pm-pending-' + variantId + '-' + (++ovSeq), id: Number(variantId), product_id: null, quantity: n,
        product_title: preview.title || '', variant_title: preview.variant || '',
        price: preview.price || 0, final_line_price: (preview.price || 0) * n,
        image: preview.image || '', url: preview.url || '',
        _loading: true, _error: false
      } };
      overlays.push(ov);
      rebuildPaint(); render(); if (wantOpen) open();
    }
    busyCount++; syncBusy();
    function drop() {
      if (!ov) return;
      overlays = overlays.filter(function (o) { return o !== ov; });
      ov = null;
    }

    return run(function () { return ensureFresh().then(function () { return addOnce(Number(variantId), n); }); })
      .then(function (cart) {
        drop(); busyCount--;
        adopt(cart); render();
        if (wantOpen) open();   /* no-op when the optimistic path already opened it */
        reconcile();
      }, function (err) {
        drop(); busyCount--;
        if (err && err.cart) adopt(err.cart); else rebuildPaint();
        render();
        document.dispatchEvent(new CustomEvent('pm:cart:error', { detail: String((err && err.message) || err) }));
        reconcile();
      })
      .then(function () { if (btn) { btn.removeAttribute('data-busy'); btn.disabled = false; } });
  }

  /* Runs INSIDE the queue, against the confirmed SERVER cart.
     Protection rides in the SAME request as the item (one round trip), decided from
     SERVER PLUS the merchandise being added — so the first add to an empty bag carries
     it (Codex R3 #1) and a cart already holding any protection line never gets a second.
     FAILURE: never replay an ambiguous write (Codex R1 #3, R2 #3). */
  function addOnce(variantId, n) {
    var before = qtyOf(SERVER, variantId);
    var bundle = !!(PROT.active && PROT.variant_id && variantId !== PROT.variant_id &&
      choice(SERVER) !== 'declined' && units(identityLines(SERVER)) === 0 && n > 0);
    var items = [{ id: variantId, quantity: n }];
    if (bundle) items.push({ id: PROT.variant_id, quantity: 1 });

    return postAdd(items).catch(function (err) {
      return api('/cart.js').then(function (cart) {
        var delta = qtyOf(cart, variantId) - before;
        if (delta >= n) return cart;                       /* it landed: lost response, or a 422 that mutated */
        if (err.definitive && delta > 0) { err.cart = cart; throw err; }  /* partial: keep what Shopify confirmed */
        if (err.definitive && delta === 0 && bundle) {
          /* Definitive rejection with protection bundled: the original can never land later,
             so ONE retry of the item alone is safe. If it succeeds, protection was the
             blocker (e.g. unpublished after this page rendered) — stop offering it. */
          return postAdd([{ id: variantId, quantity: n }]).then(function (c2) {
            PROT.active = false;
            return c2;
          }, function (err2) {
            return api('/cart.js').then(function (c3) { err2.cart = c3; throw err2; },
                                        function () { throw err2; });
          });
        }
        err.cart = cart;
        throw err;                                          /* ambiguous, or the item itself was refused */
      }, function () { throw err; });
    });
  }

  /* ---- checkout actions (both hosts) ---- */
  function hostOf(el) { return el.closest('.pm-drawer__foot, .pm-cartpage__side') || document; }
  function showMsg(el, text) {
    var m = hostOf(el).querySelector('[data-pm-protect-msg]');
    if (m) { m.textContent = text || ''; m.hidden = !text; }
  }
  function hideMsgs() {
    [].forEach.call(document.querySelectorAll('[data-pm-protect-msg]'), function (m) { m.hidden = true; m.textContent = ''; });
  }
  function setBusy(el, on) {
    if (on) el.setAttribute('aria-busy', 'true'); else el.removeAttribute('aria-busy');
  }
  function goCheckout() { window.location.assign(PROT.checkout_url || '/cart/checkout'); }

  /* Checkout latch (rk plan §2.3). A checkout never proceeds on a quantity edit that did not
     confirm: an edit that failed AFTER the tap (or whose recovery had not been SEEN yet), or a
     tap made while SERVER was unconfirmed, stops this attempt — the shopper sees the confirmed
     cart and taps again. Sequence-based, so an old, already-seen failure never blocks. */
  function qtyErr() { var e = new Error('quantity edit not confirmed'); e.qty = true; return e; }
  function gate(failAtClick, staleAtClick) {
    return ensureFresh().then(function () {
      if (staleAtClick || qtyFailSeq !== failAtClick) throw qtyErr();
    }, function () { throw qtyErr(); });
  }

  function onGo(ev, el) {
    ev.preventDefault();
    /* `locked` is shared: protected checkout and the skip link can never both be queued. */
    if (locked || el.getAttribute('aria-busy') === 'true') return;
    hideMsgs();
    flushPending();
    var failAtClick = qtyShownSeq, staleAtClick = needResync;
    locked = true; setBusy(el, true);
    run(function () {
      return gate(failAtClick, staleAtClick).then(function () {
        if (!PROT.active) { goCheckout(); return; }
        if (units(managedLines(SERVER)) === 1 && choice(SERVER) !== 'declined') { goCheckout(); return; }
        /* One request: exactly one protection unit AND the explicit choice (Codex R2 #5 —
           an explicit protected checkout always overwrites a stale `declined`). */
        var upd = {}, ml = managedLines(SERVER);
        if (ml.length) ml.forEach(function (l, i) { upd[l.key] = i === 0 ? 1 : 0; });
        else upd[PROT.variant_id] = 1;
        return api('/cart/update.js', { updates: upd, attributes: { _pm_protection: 'accepted' } }).then(function (cart) {
          adopt(cart); render();
          if (units(managedLines(SERVER)) === 1 && choice(SERVER) === 'accepted') goCheckout();
          else throw new Error('protection not confirmed');
        });
      });
    }).catch(function (err) {
      /* Never silently proceed uninsured (Codex R1 #5): say so and stay. The skip link
         remains the shopper's explicit way through. A quantity-latch stop says THAT, and is
         never overwritten by the protection message (rk plan R2 #4). */
      locked = false; setBusy(el, false);
      showMsg(el, err && err.qty ? STR.line_error : STR.protect_add_error);
      render();
    });
  }

  function onSkip(ev, el) {
    ev.preventDefault();
    if (locked || el.getAttribute('aria-busy') === 'true') return;
    hideMsgs();
    flushPending();
    var failAtClick = qtyShownSeq, staleAtClick = needResync;
    locked = true; setBusy(el, true);
    run(function () {
      return gate(failAtClick, staleAtClick).then(function () {
        var upd = {};
        identityLines(SERVER).forEach(function (l) { upd[l.key] = 0; });
        /* The attribute is written even when there is no line, so an add still in flight
           cannot bring protection back afterwards (Codex R1 #1). */
        return api('/cart/update.js', { updates: upd, attributes: { _pm_protection: 'declined' } }).then(function (cart) {
          adopt(cart); render();
          /* Money-shaped: navigate only on the CONFIRMED result (SKILL trap #9). */
          if (units(identityLines(SERVER)) === 0 && choice(SERVER) === 'declined') goCheckout();
          else throw new Error('protection still present');
        });
      });
    }).catch(function (err) {
      locked = false; setBusy(el, false);
      showMsg(el, err && err.qty ? STR.line_error : STR.protect_error);
      render();
    });
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var go = t.closest('[data-pm-protect-go]');
    if (go) { onGo(ev, go); return; }
    var sk = t.closest('[data-pm-protect-skip]');
    if (sk) onSkip(ev, sk);
  });

  /* ---- open / close ---- */
  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    root.setAttribute('data-open', 'true');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var f = root.querySelector('[data-pm-drawer-close]:not(.pm-drawer__scrim)');
    if (f) f.focus();
  }
  function close() {
    root.setAttribute('data-open', 'false');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function isOpen() { return root.getAttribute('data-open') === 'true'; }

  document.addEventListener('keydown', function (ev) {
    if (!isOpen()) return;
    if (ev.key === 'Escape') { close(); return; }
    if (ev.key !== 'Tab') return;
    var f = panel.querySelectorAll('a[href]:not([hidden]),button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
    else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
  });

  root.addEventListener('click', function (ev) {
    var t = ev.target;
    if (t.closest('[data-pm-drawer-close]')) { ev.preventDefault(); close(); return; }
    var line = t.closest('[data-pm-line]');
    if (!line) return;
    var key = line.getAttribute('data-key');
    var cur = find(key); if (!cur) return;
    if (t.closest('[data-pm-qty-dec]')) setQty(key, cur.quantity - 1);
    else if (t.closest('[data-pm-qty-inc]')) setQty(key, cur.quantity + 1);
    else if (t.closest('[data-pm-line-remove]')) setQty(key, 0);
  });

  /* ---- in-cart add-ons (server-rendered; JS handles the click and re-hides owned cards) ---- */
  function onUpsellAdd(ev, host) {
    var btn = ev.target.closest('[data-pm-upsell-add]');
    if (!btn) return;
    ev.preventDefault();
    var li = btn.closest('[data-pm-upsell-item]');
    var img = li && li.querySelector('img');
    var t = li && li.querySelector('.pm-upsell__title');
    var pr = li && li.querySelector('.t-price');
    add(btn.getAttribute('data-pm-upsell-add'), 1, btn, {
      title: t ? t.textContent.trim() : '',
      variant: '',
      price: pr ? Math.round(parseFloat(pr.textContent.replace(/[^0-9.]/g, '')) * 100) || 0 : 0,
      image: img ? img.getAttribute('src') : '',
      url: t ? t.getAttribute('href') : ''
    }, { open: host !== 'page' });
  }
  root.addEventListener('click', function (ev) { onUpsellAdd(ev, 'drawer'); });

  /* ---- the PDP companion piece (a real form; intercepted here) ---- */
  document.addEventListener('submit', function (ev) {
    var f = ev.target.closest('[data-pm-pair-add]');
    if (!f) return;
    ev.preventDefault();
    var id = f.querySelector('input[name="id"]');
    if (!id || !id.value) return;
    var btn = f.querySelector('button');
    var row = f.closest('.pm-pair__row');
    var t = row && row.querySelector('.pm-pair__title');
    var pr = row && row.querySelector('.pm-pair__price');
    var img = row && row.querySelector('img');
    add(id.value, 1, btn, {
      title: t ? t.textContent.trim() : '',
      variant: '',
      price: pr ? Math.round(parseFloat(pr.textContent.replace(/[^0-9.]/g, '')) * 100) || 0 : 0,
      image: img ? img.getAttribute('src') : '',
      url: t ? t.getAttribute('href') : ''
    });
  });

  function syncPair() {
    var pair = document.querySelector('[data-pm-pair]');
    if (!pair) return;
    var link = pair.querySelector('.pm-pair__title');
    if (!link) return;
    var handle = (link.getAttribute('href') || '').split('/products/')[1] || '';
    handle = handle.split('?')[0];
    var present = CART.items.some(function (l) {
      var u = (l.url || '').split('/products/')[1] || '';
      return handle && u.split('?')[0] === handle;
    });
    pair.hidden = present;
  }

  /* ---- re-pick the in-bag add-ons from the co-purchase map (both hosts) ---- */
  var pairCache = {};
  var upsellGen = new WeakMap();

  function upsellWraps() {
    var out = [];
    var a = root.querySelector('[data-pm-upsell]');
    if (a) out.push(a);
    var b = pageRoot && pageRoot.querySelector('[data-pm-upsell]');
    if (b && b !== a) out.push(b);
    return out;
  }

  function upsellMap(wrap) {
    var raw = wrap.getAttribute('data-pm-pair-map') || '';
    var m = {};
    raw.split(',').forEach(function (e) {
      var lr = e.split('>');
      if (lr.length === 2) m[lr[0]] = (lr[1].split(':')[0] || '');
    });
    return m;
  }

  function upsellCard(p, labels) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    var single = (p.variants || []).length === 1 && v;
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var price = (typeof p.price === 'number') ? money(p.price) : '';
    var act = single
      ? '<form action="/cart/add" method="post" enctype="multipart/form-data" class="pm-upsell__form" data-pm-upsell-form>'
        + '<input type="hidden" name="id" value="' + v.id + '">'
        + '<input type="hidden" name="quantity" value="1">'
        + '<button type="submit" class="pm-upsell__btn t-label" data-pm-upsell-add="' + v.id + '">'
        + esc(labels.add) + '<span class="visually-hidden"> — ' + esc(p.title) + '</span>'
        + '</button></form>'
      : '<a class="pm-upsell__btn pm-upsell__btn--link t-label" href="/products/' + p.handle + '">'
        + esc(labels.size) + '<span class="visually-hidden"> — ' + esc(p.title) + '</span></a>';
    return '<li class="pm-upsell__item" data-pm-upsell-item data-product-id="' + p.id + '">'
      + '<a class="pm-upsell__frame" href="/products/' + p.handle + '" tabindex="-1" aria-hidden="true">'
      + (img ? '<img src="' + esc(img) + '" alt="" width="56" height="70" loading="lazy">' : '')
      + '</a><div class="pm-upsell__meta">'
      + '<a class="pm-upsell__title t-product" href="/products/' + p.handle + '">' + esc(p.title) + '</a>'
      + '<span class="t-price">' + price + '</span></div>' + act + '</li>';
  }

  function refreshUpsell(wrap) {
    var map = upsellMap(wrap);
    if (realCount(CART) === 0) return;
    var limit = parseInt(wrap.getAttribute('data-pm-upsell-limit') || '2', 10);
    var inBag = {}, want = [];
    CART.items.forEach(function (l) { if (l.handle) inBag[l.handle] = true; });
    CART.items.forEach(function (l) {
      if (want.length >= limit || isManaged(l)) return;
      var h = map[l.handle];
      if (h && !inBag[h] && want.indexOf(h) === -1) want.push(h);
    });
    if (!want.length) return;

    var labels = {
      add: wrap.getAttribute('data-pm-add-label') || 'ADD',
      size: wrap.getAttribute('data-pm-size-label') || 'CHOOSE SIZE'
    };
    var gen = (upsellGen.get(wrap) || 0) + 1;
    upsellGen.set(wrap, gen);

    Promise.all(want.map(function (h) {
      if (pairCache[h]) return Promise.resolve(pairCache[h]);
      return fetch('/products/' + h + '.js', {headers: {Accept: 'application/json'}})
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { pairCache[h] = p; return p; })
        .catch(function () { return null; });
    })).then(function (ps) {
      if (upsellGen.get(wrap) !== gen) return;
      var good = ps.filter(function (p) { return p && p.available; });
      if (!good.length) return;
      var list = wrap.querySelector('.pm-upsell__list');
      if (list) list.innerHTML = good.map(function (p) { return upsellCard(p, labels); }).join('');
      wrap.hidden = false;
      hideOwned(wrap);
    });
  }

  function hideOwned(wrap) {
    var ids = {};
    CART.items.forEach(function (l) { if (l.product_id) ids[l.product_id] = true; });
    var left = 0;
    [].forEach.call(wrap.querySelectorAll('[data-pm-upsell-item]'), function (li) {
      var inCart = !!ids[li.getAttribute('data-product-id')];
      li.hidden = inCart;
      if (!inCart) left++;
    });
    wrap.hidden = (realCount(CART) === 0) || left === 0;
  }

  function syncUpsell() {
    syncPair();
    [].forEach.call(upsellWraps(), function (wrap) {
      refreshUpsell(wrap);
      hideOwned(wrap);
    });
  }

  root.addEventListener('change', function (ev) {
    var input = ev.target.closest('[data-pm-qty-input]');
    if (!input) return;
    var line = input.closest('[data-pm-line]');
    var n = parseInt(input.value, 10);
    setQty(line.getAttribute('data-key'), isNaN(n) || n < 0 ? 0 : n);
  });

  /* ---- the same handlers, bound to the /cart page ---- */
  if (pageRoot) {
    pageRoot.addEventListener('click', function (ev) { onUpsellAdd(ev, 'page'); });
    pageRoot.addEventListener('click', function (ev) {
      var line = ev.target.closest('[data-pm-line]');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var cur = find(key); if (!cur) return;
      if (ev.target.closest('[data-pm-qty-dec]')) setQty(key, cur.quantity - 1);
      else if (ev.target.closest('[data-pm-qty-inc]')) setQty(key, cur.quantity + 1);
      else if (ev.target.closest('[data-pm-line-remove]')) setQty(key, 0);
    });
    pageRoot.addEventListener('change', function (ev) {
      var input = ev.target.closest('[data-pm-qty-input]');
      if (!input) return;
      var line = input.closest('[data-pm-line]');
      var n = parseInt(input.value, 10);
      setQty(line.getAttribute('data-key'), isNaN(n) || n < 0 ? 0 : n);
    });

    /* With JS running the cart form NEVER submits. Checkout is handled by the click
       handler above (queued, then a direct navigation), and a positional updates[]
       re-post rendered from a snapshot could land quantities on the wrong lines
       (Codex R1 #4). Enter in a quantity field would otherwise submit it. The form and
       its updates[] remain the no-JS path only. */
    if (pgForm) {
      pgForm.addEventListener('submit', function (ev) { ev.preventDefault(); });
    }
  }

  /* The bag control is a real <a href="/cart">; JS upgrades it to the drawer. */
  [].forEach.call(document.querySelectorAll('[data-pm-bag], .cart__toggle'), function (b) {
    b.addEventListener('click', function (ev) { ev.preventDefault(); open(); });
  });

  /* BFCache: Back out of checkout restores this heap — including `locked` from the
     checkout that navigated away (Codex R4 #1). Reset everything, then resync. */
  window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted) return;
    Object.keys(timers).forEach(function (k) { clearTimeout(timers[k]); });
    timers = {}; pendingQty = {}; qtyOverlay = {}; overlays = []; errKeys = {};
    cycleBase = {}; cycleIdent = {}; cycleSeq = {};
    qtyShownSeq = qtyFailSeq;   /* nothing unseen survives a restore: the cart is re-read below */
    queue = Promise.resolve();
    busyCount = 0; locked = false;
    [].forEach.call(document.querySelectorAll('[data-pm-protect-go],[data-pm-protect-skip]'), function (b) {
      b.removeAttribute('aria-busy');
    });
    hideMsgs();
    api('/cart.js').then(function (c) { needResync = false; adopt(c); render(); reconcile(); },
                         function () { needResync = true; rebuildPaint(); render(); });
  });

  window.PMCart = {
    open: open, close: close, add: add,
    state: function () { return CART; },
    server: function () { return SERVER; }
  };
  rebuildPaint();
  render();

  /* READINESS IS PUBLISHED LAST, after render() — pm-atc-guard / pm-nav-guard resume
     a queued tap on this signal. */
  document.documentElement.setAttribute('data-pm-cart-ready', '');
  document.dispatchEvent(new CustomEvent('pm:cart:ready'));

  /* Carts filled by paths that bypassed PMCart.add (a no-JS POST, an app's own add, a
     return from checkout) are brought to I1–I3 here, in the background. */
  reconcile();
})();


/* ===== navigation prefetch =================================================
   Derrick 2026-09-01: "make everything feel as fast as possible."

   A tap on a product card starts a full page load only AFTER the finger lifts.
   Fetching on touchstart buys the ~90-300ms between press and release, and on a
   slow connection that is the difference between "instant" and "laggy". Desktop
   gets the same on hover, where the lead time is longer still.

   Deliberately conservative:
     * same-origin only, and never the current page
     * NEVER /cart, /checkout or /account — prefetching a stateful or mutating
       route is how you get phantom carts and skewed analytics
     * skipped entirely under Save-Data, and on 2g
     * capped, so a shopper thumbing down 42 cards cannot spawn 42 requests
     * <link rel=prefetch> is a HINT at the lowest priority; it never competes
       with anything the current page still needs
   ========================================================================= */
(function () {
  var c = navigator.connection;
  if (c && (c.saveData || /2g/.test(c.effectiveType || ''))) return;
  try {
    if (!document.createElement('link').relList.supports('prefetch')) return;
  } catch (e) { return; }

  var seen = {}, used = 0, LIMIT = 6;

  function candidate(a) {
    if (!a || !a.getAttribute('href')) return null;
    if (a.hasAttribute('download') || a.target === '_blank') return null;
    var u;
    try { u = new URL(a.href, location.href); } catch (e) { return null; }
    if (u.origin !== location.origin) return null;
    if (u.pathname === location.pathname) return null;
    if (/^\/(cart|checkout|account|challenge)/.test(u.pathname)) return null;
    return u.href;
  }

  function prefetch(url) {
    if (!url || seen[url] || used >= LIMIT) return;
    seen[url] = 1; used++;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    l.as = 'document';
    document.head.appendChild(l);
  }

  function onIntent(ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    prefetch(candidate(t.closest('a[href]')));
  }

  document.addEventListener('touchstart', onIntent, { passive: true, capture: true });
  document.addEventListener('mouseover', onIntent, { passive: true, capture: true });
})();
